import { render, staticRenderFns } from "./team-list-detail.html?vue&type=template&id=4100d103&"
import script from "./team-list-detail.ts?vue&type=script&lang=ts&"
export * from "./team-list-detail.ts?vue&type=script&lang=ts&"
import style0 from "./team-list-detail.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports